<template>
  <div>
    <h1>404</h1>
    <div class="display-4">This page does not exist.</div>

  </div>
</template>
